module.exports = __webpack_public_path__ + "assets/156ff72a80dea456165b45dc1b9f073e.png";